import S from '../Home/Home.module.scss';

import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { fetchUsersMe } from '../../../repository/LoginRepository';
import { AuthUtils } from '../../../utils/AuthUtils';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { IvyAuthorizationTokenAtom, IvyMyInfoAtom } from '../../../recoil/Authorization.recoil';
import HomeProfile from './HomeProfile';
import RecruitmentCard from '../../common/RecruitmentCard';
import {fetchHomeResume, fetchResumes} from '../../../repository/ResumeRepository';
import {HomeMyResumeType, HomeResumeType, ResumeType} from '../../../types/ResumeTypes';
import HomeMyResume from './HomeMyResume';
import {BookmarkType, RecruitmentContentType, RecruitmentFilterType} from '../../../types/RecruitmentTypes';
import {fetchBookmarks, fetchRecruitments} from '../../../repository/RecruitmentRepository';
import {BookmarksAtom} from "../../../recoil/Recruitment.recoil";
import bookmark from "../../common/Bookmark";

/*
 * 메인 페이지
 *  */
const Home = () => {
  const [myInfo, setMyInfo] = useRecoilState(IvyMyInfoAtom);
  const setToken = useSetRecoilState(IvyAuthorizationTokenAtom);
  const token = AuthUtils.getCookie('token');
  const isLogin = AuthUtils.isLoggedIn();
  const [hasResume, setHasResume] = useState<boolean>(false);

  const HOME_RECRUITMENT_LIST_SIZE = 9;
  const [homeContent, setHomeContent] = useState<HomeResumeType>({} as HomeResumeType);
  const [recruitments, setRecruitments] = useState<RecruitmentContentType[]>([]);
  const [bookmarks, setBookmarks] = useRecoilState<BookmarkType[]>(BookmarksAtom);
  const getRecruitmentList = () => {
    fetchRecruitments('', [], true, '', HOME_RECRUITMENT_LIST_SIZE, token).then((res) => {
      if (res && res.content.length > 0) {
        setRecruitments(res.content);
      }
    }).catch((e) => console.error(e));
  };

  const fetchHomeApi = () => {
    fetchHomeResume(token).then((res) => {
      if(res) {
        setHomeContent(res);
        if(res.me?.bookmarks) {
          setBookmarks(res.me.bookmarks);
        }

        //resume
        if(res.me?.representativeResume?.id > 0){
          setHasResume(true);
        }else{
          setHasResume(false);
        }
      }
    })
  }

  useEffect(() => {
    if (!_.isEmpty(token)) {
      setToken(token);
      fetchUsersMe(token)
        .then((res) => {
          if (res.status === 'NORMAL') {
            setMyInfo(res);
          } else {
            console.log('에러발생');
          }
        })
        .catch((error) => console.error(error));
    }
    //공고 호출
    getRecruitmentList();
  }, []);

  useEffect(() => {
    if (isLogin && token) {
      fetchHomeApi();
    }
  }, [isLogin]);

  useEffect(() => {
    if (isLogin && token) {
      getRecruitmentList();
    }
  }, [bookmarks]);

  return (
    <>
      <main className={`${S.home_container} wrapper`}>
        {/* 상단 배너 & 이력서 영역 시작 */}
        {/* case01_로그인 전, case02_로그인 후 이력서 작성 전 */}
        <section className={S.hero_section}>
          {isLogin && hasResume ? (
            <>
              <HomeProfile resume={homeContent.me?.representativeResume} />
              <HomeMyResume hasResume={hasResume} score={homeContent.me?.resumeScore || null} avgScore={homeContent.avgScore} bookmarks={bookmarks} />
            </>
          ) : (
            <>
              <MainBanner />
              <HomeMyResume hasResume={hasResume} score={homeContent.me?.resumeScore || null} avgScore={homeContent.avgScore} bookmarks={bookmarks} />
            </>
          )}
        </section>
        <section className={S.recruit_post_wrap}>

          {recruitments.map((recruitment, index) => {
              return <RecruitmentCard key={`home_card_${index}`} content={recruitment} />;
            })}
        </section>
        {/* 채용정보 카드 리스트 영역 끝 */}
      </main>
    </>
  );
};

export default Home;

const MainBanner = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={S.banner_img_area}>
        <h2 className={S.inner_text}>하나의 이력서로,</h2>
        <h1 className={S.inner_text}>모든 채용 준비 끝!</h1>
        <p className={S.inner_sub_text}>
          이력서 작성부터 합격 예측까지,
          <br />전 과정을 아이비리거와 쉽고 빠르게 해결하세요.
        </p>
        <button type="button" className={S.resume_regist_btn}>
          <p className="button-m" onClick={() => navigate('/resume')}>
            이력서 작성하기
          </p>
        </button>
      </div>
    </>
  );
};
